import * as appKeys from 'app/school-master/app-keys'
import * as actionTypes from 'app/school-trigger/constants/action-types'

window.addEventListener("load", function() {
    if(!window.AboundSchoolMaster) return

    const dispatch = (action) => {
        const store = window.AboundSchoolMaster.getStore(appKeys.SCHOOL_TRIGGER, appIndex)
        store && store.dispatch(action)
    }

    const appIndex = window.AboundSchoolMaster.registerApp(appKeys.SCHOOL_TRIGGER, {
        state: {},
        reducer: x => x,
        components: [],
    })

    window.AboundSchoolTrigger = {
        openLogin: () => { dispatch({type: actionTypes.OPEN_LOGIN}) },
        openSignup: () => {
            dispatch({type: actionTypes.OPEN_LOGIN})
            dispatch({type: actionTypes.SHOW_SIGNUP})
        },
    }
})



// WEBPACK FOOTER //
// ./react/school-trigger.js